import { atom } from "recoil";

export const MainCategoryState = atom({
    key: "MainCategoryState",
    default: null
})